import React, { Component } from 'react';
import './styles.css';

export default class Modal extends Component {

  render() {
    return (
      <div className="modal-component">
        <div className="modal-backdrop" onClick={this.props.disableDismissal ? null : this.props.onDismiss}/>
        <div className={`modal-container ${this.props.className || ''}`}>
          {!this.props.disableDismissal && this.props.onDismiss && <div className="modal-close-button" role="button" onClick={this.props.onDismiss}>×</div>}
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/index.js